module.exports = __webpack_public_path__ + "media/images/header-logo-921bb01fc65b11952a0baecbd0eee02e.png";